import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { transactionsService } from "../services/transactionService";
import { useToast } from "../../view/components/ui/use-toast";
import { useEffect } from "react";

export const useTransactionId = (id: string) => {
  const baseQueryKey = ["transactions", "transactionById", id];

  const {
    data: storedData,
    isError,
    isFetching,
    isLoading,
  } = useQuery({
    queryKey: [...baseQueryKey, "store"],
    queryFn: async () =>
      transactionsService.transactionById(id, { store: true }),
    placeholderData: keepPreviousData,
    enabled: Boolean(id),
  });

  const {
    data: syncedData,
    isFetching: isSyncing,
    isError: isSyncError,
  } = useQuery({
    queryKey: baseQueryKey,
    queryFn: async () => transactionsService.transactionById(id),
    enabled: Boolean(id),
    retry: false,
  });

  const { toast } = useToast();

  useEffect(() => {
    if (isError) {
      toast({
        variant: "destructive",
        title: "Erro ao carregador os dados, tente novamente mais tarde!",
      });
    }
  }, [isError, toast]);

  return {
    isLoading,
    isFetching,
    data: syncedData ?? storedData,
    isSyncing,
    isSyncError,
  };
};
